import React from "react";
import { Box, Switch, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const SwitchColors = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Switch Colors
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          Switch provides 7 colors: default, primary, secondary, error, warning,
          info and success.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={
            "Basic switches Colors. 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' "
          }
          language={"js"}
          value={
            '      <Switch defaultChecked />\n' +
            '      <Switch defaultChecked color={"primary"} />\n' +
            '          <Switch defaultChecked color={"secondary"} />\n' +
            '          <Switch defaultChecked color={"error"} />\n' +
            '          <Switch defaultChecked color={"warning"} />\n' +
            '          <Switch defaultChecked color={"info"} />\n' +
            '          <Switch defaultChecked color={"success"} />'
          }
        >
          <Switch defaultChecked />
          <Switch defaultChecked color={"primary"} />
          <Switch

            defaultChecked
            color={"secondary"}
          />
          <Switch defaultChecked color={"error"} />
          <Switch defaultChecked color={"warning"} />
          <Switch defaultChecked color={"info"} />
          <Switch defaultChecked color={"success"} />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default SwitchColors;
